import { getCompanies } from '../../api/companies'
import getToken from '../account/getToken'

const hydrateCompanies = store => async () => {
  const {
    companyListPage,
    companyListSortBy,
    companyListSortDirection,
    companyListSearch,
    companyListFilters,
  } = store.getState()

  let token

  try {
    token = await getToken(store)()
    // No token
    if (!token) {
      store.setState({
        isHydratingCompanies: false,
      })
      return
    }
  } catch (err) {
    return
  }


  store.setState({
    isHydratingCompanies: true,
  })

  return getCompanies({
    token,
    page: companyListPage,
    sortBy: companyListSortBy,
    sortDirection: companyListSortDirection,
    search: companyListSearch,
    filters: companyListFilters,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })

    .then(({companies, totalCompanies}) => {
      // Hydrate companies
      store.setState({
        companies,
        totalCompanies,
        isHydratingCompanies: false,
      })
    })
    .catch(error => {
      console.log(error)
      store.setState({
        isHydratingCompanies: false,
      })
    })
}

export default hydrateCompanies
